<!--疑似窜货热力图-->
<template>
	<div>
		<h3>疑似窜货热力图</h3>
		<div>
            <div class="lines">
                <el-form ref="form" :model="form" inline :rules="rules">
                    <el-form-item prop="date" style="width: 150px;">
						<el-radio-group v-model="form.date">
                            <el-radio-button label="本月"></el-radio-button>
                            <el-radio-button label="本年"></el-radio-button>
                        </el-radio-group>
					</el-form-item>
                    <el-form-item prop="makeTime" style="width: 360px;padding-top: 1px;">
                        <el-date-picker
                        v-model="form.makeTime" clearable
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
					</el-form-item>
                    <el-form-item prop="productForm.Productname" style="width: 210px;">
						<el-input placeholder="全部商品" :value="form.productForm.Productname" @focus="productfocus"></el-input>
					</el-form-item>
                    <el-button @click="restForm" style="margin-top: 1px;" type="warning">重 置</el-button>
                </el-form>
                <div class="map">
                    <div :style="{height:'500px',width:'50%'}" ref="eChart1" id="echart1"></div>
                    <div :style="{height:'500px',width:'22%',float:'left'}" ref="eChart2" id="echart2"></div>
                    <div :style="{height:'500px',width:'22%',float:'left'}" ref="eChart3" id="echart3"></div>
                </div>
            </div>
            <div class="item">
                <el-button type="primary" style="margin-bottom: 15px;">导 出</el-button>
                <el-table border>
                    <el-table-column align="center" property="DataId" label="排名"></el-table-column>
                    <el-table-column align="center" property="Productcode" label="疑似窜货流入省市"></el-table-column>
                    <el-table-column align="center" property="Productname" label="疑似窜货数量"></el-table-column>
                </el-table>
            </div>
		</div>
	</div>
</template>

<script>
import echarts from "echarts";//引入图表
import '../../node_modules/echarts/map/js/china.js' // 引入中国地图数据

export default {
	data(){
		return {
            form:{
                date:'本月',
                makeTime:'',
                productForm:{
					Productcode:'',
					Productname:'',
					Norms:''
				},
            },
            rules: {
        		makeTime:[
          			{ required: true, message: '请选择时间', trigger: 'change' }
        		]
			},
            option1 : {
                tooltip: {}, // 鼠标移到图里面的浮动提示框
                dataRange: {
                    show: false,
                    min: 0,
                    max: 1000,
                    text: ['High', 'Low'],
                    realtime: true,
                    calculable: true,
                    color: ['orangered', 'yellow', 'lightskyblue']
                },
                geo: { // 这个是重点配置区
                    map: 'china', // 表示中国地图
                    zoom:1,
                    roam: false,//支持扩大缩小
                    label: {
                        normal: {
                            show: true, // 是否显示对应地名
                            textStyle: {
                            color: 'rgba(0,0,0,0.6)'
                            }
                        }
                    },
                    itemStyle: {
                        normal: {
                            borderColor: 'rgba(0, 0, 0, 0.4)'
                        },
                        emphasis: {
                            areaColor: null,
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            shadowBlur: 20,
                            borderWidth: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                },
                series: [{
                    type: 'scatter',
                    selectedMode: 'single',
                    coordinateSystem: 'geo' // 对应上方配置
                    },
                    {
                    name: '数量', // 浮动框的标题
                    type: 'map',
                    geoIndex: 0,
                    data: [{
                        "name": "北京",
                        "value": 599
                    }, {
                        "name": "上海",
                        "value": 142
                    }, {
                        "name": "黑龙江",
                        "value": 44
                    }, {
                        "name": "深圳",
                        "value": 92
                    }, {
                        "name": "湖北",
                        "value": 810
                    }, {
                        "name": "四川",
                        "value": 453
                    },{
                        "name": "湖南",
                        "value": 125
                    }]
                    }
                ]
            },
            index1:0,
            index2:0,
            option2 : {
                color: ['#3398DB'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: [
                    {
                        type: 'category',
                        data: ['北京', '天津', '河北', '山西', '内蒙古', '辽宁', '吉林', '黑龙江', '上海', '江苏', '浙江', '安徽',
                               '福建', '江西', '山东', '河南', '湖北', '湖南',],
                        show:true,
                        axisLine:{
                            show:false
                        },
                        axisTick: {
                            show: false,
                        },
                        splitLine:{
                            show: false,
                        },
                        inverse:true,
                        axisLabel:{
                            margin: 100,
                            fontSize: 13,
                            align: 'left',
                            rich: {
                                a1: {
                                    color: '#fff',
                                    backgroundColor: '#f36c6c',
                                    width: 30,
                                    height: 20,
                                    align: 'center',
                                    borderRadius: 2
                                },
                                a2: {
                                    color: '#fff',
                                    backgroundColor: '#e6cf4e',
                                    width: 30,
                                    height: 20,
                                    align: 'center',
                                    borderRadius: 2
                                },
                                a3: {
                                    color: '#fff',
                                    backgroundColor: '#20d180',
                                    width: 30,
                                    height: 20,
                                    align: 'center',
                                    borderRadius: 2
                                },
                                b: {
                                    color: '#fff',
                                    backgroundColor: '#0093ff',
                                    width: 30,
                                    height: 20,
                                    align: 'center',
                                    borderRadius: 2
                                }
                            },
                            formatter: this.GetIndex1,
                        },
                        
                    }
                ],
                xAxis: [
                    {
                        show:false,
                        type: 'value',
                        splitLine:'false'
                    }
                ],
                series: [
                    {
                        name: '窜货数量',
                        type: 'bar',
                        data: [599, 142, 44, 92, 810, 453, 125],
                        barWidth: 16,
                        itemStyle: {
                            emphasis: {
                                barBorderRadius: [0,7,7,0]
                            },
                            normal: {
                                barBorderRadius: [0,7,7,0]
                            }
                        }
                    }
                ]
            }, 
            option3 : {
                color: ['#3398DB'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: [
                    {
                        type: 'category',
                        data: ['广东', '广西', '海南', '四川', '重庆', '贵州', '云南',
                               '陕西', '甘肃', '青海', '宁夏', '新疆', '西藏', '香港', '澳门', '台湾', '其它'],
                        show:true,
                        axisLine:{
                            show:false
                        },
                        axisTick: {
                            show: false,
                        },
                        splitLine:{
                            show: false,
                        },
                        inverse:true,
                        axisLabel:{
                            margin: 100,
                            fontSize: 13,
                            align: 'left',
                            rich: {
                                b: {
                                    color: '#fff',
                                    backgroundColor: '#0093ff',
                                    width: 30,
                                    height: 20,
                                    align: 'center',
                                    borderRadius: 2
                                }
                            },
                            formatter: this.GetIndex2,
                        },
                    }
                ],
                xAxis: [
                    {
                        show:false,
                        type: 'value',
                        splitLine:'false'
                    }
                ],
                series: [
                    {
                        name: '窜货数量',
                        type: 'bar',
                        data: [599, 142, 44, 92, 810, 453, 125],
                        barWidth: 16,
                        itemStyle: {
                            emphasis: {
                                barBorderRadius: [0,7,7,0]
                            },
                            normal: {
                                barBorderRadius: [0,7,7,0]
                            }
                        }
                    }
                ]
            }, 
		};
	},
	mounted : function(){
		var user = JSON.parse(sessionStorage.getItem('user'));
        this.initEcharts()
        
        var elementResizeDetectorMaker = require("element-resize-detector");//导入
        // 创建实例
        var erd = elementResizeDetectorMaker();
        // 创建实例带参
        var erdUltraFast = elementResizeDetectorMaker({
                        strategy: "scroll", //<- For ultra performance.
                        callOnAdd: true,
                        debug: true
                    });
        //监听id为test的元素 大小变化
        erd.listenTo(document.getElementById("echart1"), function(element) {
             let  myChart1 = echarts.init(document.getElementById('echart1'));
             myChart1.resize();
        });
        erd.listenTo(document.getElementById("echart2"), function(element) {
             let  myChart2 = echarts.init(document.getElementById('echart2'));
             myChart2.resize();
        });
        erd.listenTo(document.getElementById("echart3"), function(element) {
             let  myChart3 = echarts.init(document.getElementById('echart3'));
             myChart3.resize();
        });
	},
	methods: {
        //初始化
        initEcharts(){
            let  myChart1 = echarts.init(this.$refs.eChart1);
            myChart1.on("click", this.eChartOnclick);
            myChart1.setOption(this.option1);
            
            let  myChart2 = echarts.init(this.$refs.eChart2);
            myChart2.setOption(this.option2);

            let  myChart3 = echarts.init(this.$refs.eChart3);
            myChart3.setOption(this.option3);
        },
        productfocus(){//获取商品
			this.productVisible=true;
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Product.ashx',
				params: {
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
				if(res.Code==0){
					this.productData=res.DataList;
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					});
				}      
			})
        },
        eChartOnclick(param){
            this.option2.geo.map=param.name
            console.log(param.name)
            let  myChart2 = echarts.init(this.$refs.eChart2);
            myChart2.setOption(this.option2);
        },
        restForm(){//重置表单
			this.$nextTick(()=>{
				this.$refs['form'].resetFields()
			})
			this.form.productForm.Productcode = '';
			this.form.productForm.Productname = '';
			this.form.productForm.Norms = '';
        },
        GetIndex1(params) {
            if (this.index1 == 18) {
                this.index1 = 0;
            }
            this.index1++;
            if (this.index1 - 1 < 3) {
                return [
                    '{a' + this.index1 + '|' + this.index1 + '}' + '  ' + params
                ].join('\n')
            } else {
                return [
                    '{b|' + this.index1 + '}' + '  ' + params
                ].join('\n')
            }
        },
        GetIndex2(params) {
            if (this.index2 == 17) {
                this.index2 = 0;
            }
            this.index2++;
            var index=this.index2+18
            return [
                    '{b|' + index + '}' + '  ' + params
                ].join('\n')
        }
	}
}
</script>

<style scoped>
.lines{
    width: 100%;
    background: #f8f8f8;
    padding: 10px;
    margin-bottom: 20px;
}
.map{
    margin-top: 20px;
    padding: 10px 10px;
    background: #f8f8f8;
    overflow:hidden;
    zoom:1;
}
.map div{
    float: left;
}
</style>


// WEBPACK FOOTER //
// src/pages/fcHeating.vue